import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor() { }

  hasPermission(requiredPermission: string): boolean {
    const permissions = JSON.parse(localStorage.getItem('roles') || '[]');

    return permissions.includes(requiredPermission);
  }
}
